import { Badge, Switch } from '@lib/components'
import { openModal } from '@storeOld/reducers/ui'
import cx from 'classnames'
import type React from 'react'
import { useDispatch } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { MODAL_UPGRADE_PLAN } from '../../../../App/Modal/constants'
import cssPublish from '../../Publish.module.scss'
import css from './SettingsSwitcher.module.scss'

type Props = {
  text: string
  checked: boolean
  withBadge?: boolean
  onChange: (value: boolean) => void
}

export const SettingsSwitcher: React.FC<Props> = ({
  text,
  checked,
  withBadge,
  onChange,
}) => {
  const dispatch = useDispatch()

  const onClickBadge = () => {
    sendGtmEvent(GtmTriggerName.UPGRADE_EXPORT)
    dispatch(openModal(MODAL_UPGRADE_PLAN))
  }

  return (
    <div>
      <div className={cx(css.container, { [css.withBadge]: withBadge })}>
        {text}
        {withBadge ? (
          <Badge type="plan_pro" onClick={onClickBadge} />
        ) : (
          <Switch
            mode="thin"
            checked={checked}
            classes={{ container: css.switcher }}
            onChange={onChange}
          />
        )}
      </div>
      <div className={cssPublish.divider} />
    </div>
  )
}
